var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.productId === 26182)?_c('div',{staticClass:"skuratov"},[_vm._v(_vm._s(_vm.value))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }